import Step from "@/model/progress/Step"
import StepId from "@/model/progress/StepId"

const patientInfo = new Step({
    id: StepId.PATIENT_INFO,
    title: "step.patientInfo",
    isComplete: false,
})
const jointApplicant = new Step({
    id: StepId.JOINT_APPLICANT_INFO,
    title: "step.jointApplicantInfo",
    isComplete: false,
})
const paymentOptions = new Step({
    id: StepId.PAYMENT_OPTIONS,
    title: "step.paymentOptions",
    isComplete: false,
})
const acceptOffer = new Step({
    id: StepId.ACCEPT_OFFER,
    title: "step.acceptOffer",
    isComplete: false,
})
const terms = new Step({
    id: StepId.TERMS,
    title: "step.terms",
    isComplete: false,
})
const complete = new Step({
    id: StepId.COMPLETE,
    title: "step.complete",
    isComplete: false,
})

const StepsByMode = {
    full: [{ ...patientInfo }, { ...terms }, { ...paymentOptions }, { ...complete }],
    fullJoint: [{ ...patientInfo }, { ...jointApplicant }, { ...terms }, { ...paymentOptions }, { ...complete }],
    prequalify: [{ ...patientInfo }, { ...paymentOptions }, { ...acceptOffer }, { ...complete }],
    prescreen: [{ ...patientInfo }, { ...paymentOptions }, { ...acceptOffer }, { ...complete }],
    noOffer: [{ ...patientInfo }, { ...complete }],
    null: [],
}

export default StepsByMode
